import React, { PropsWithChildren } from "react";
import "./bottom-menu-panel.css";

/** Component for wrap bottom menu panels with, to make the panels the same style */
export function BottomMenuPanel({
	className,
	children,
	ref,
}: PropsWithChildren<{ className?: string; ref?: React.Ref<HTMLDivElement> }>) {
	return (
		<div className={`bottom-menu-panel ${className || ""}`} ref={ref}>
			{children}
		</div>
	);
}
BottomMenuPanel.displayName = "BottomMenuPanel";
